var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-skills"},[_c('h3',{staticClass:"title"},[_vm._v("Vaardigheden")]),_vm._v(" "),_c('ul',{staticClass:"skills-list"},_vm._l((_vm.skillsIn),function(skill){return _c('li',{key:skill.id,staticClass:"skill-item"},[_vm._v("\n            "+_vm._s(skill.name)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }